import React from 'react';
import LocationSearchInput from '../components/LocationSearchInput';
import _ from 'lodash';
import * as ff from '../constants/FormFields';
import stateOptions from './stateOptions';
import countryOptions from './countryOptions';
import CustomNumberInput from '../components/CustomNumberInput';

import conditionOptions from './conditionOptions';
import attendanceOptions from './attendanceOptions';
import cardRetOptions from './cardRetOptions';
import cardHolderPresOptions from './cardHolderPresOptions';
import panEntryOptions from './panEntryOptions';
import pinEntryOptions from './pinEntryOptions';
import terminalLocOptions from './terminalLocOptions';
import inputCapOptions from './inputCapOptions';
import terminalOpOptions from './terminalOpOptions';
import terminalTypeOptions from './terminalTypeOptions';
import cardPresenceOptions from './cardPresenceOptions';
import securityConditionOptions from './securityConditionOptions';
import presentmentOptions from './presentmentOptions';
import transactionTypeOptions from './transactionTypeOptions';

import * as VN from '../constants/VendorNames';
import * as util from '../utils';

export const basicFields = {
    [ff.AUTH_PAYMENT_TYPE]: '',
    [ff.TRANS_TYPE]: '',
    [ff.TRANS_CONVERSION_RATE]: '',
    [ff.AUTH_CARD_NUMBER]: '',
    [ff.AUTH_CVV]: '',
    [ff.AUTH_PIN]: '',
    [ff.TRANS_CURRENCY]: '',
    [ff.AUTH_EXPIRATION_DATE]: '',
    [ff.AUTH_BILLING_ADDRESS]: '',
    [ff.AUTH_CITY]: '',
    [ff.AUTH_COUNTRY]: '',
    [ff.AUTH_ZIPCODE]: '',
    [ff.MERCH_PLATFORM_NAME]: '',
    [ff.MERCH_ADDRESS]: '',
    [ff.MERCH_CITY]: '',
    [ff.MERCH_STATE]: '',
    [ff.MERCH_COUNTRY]: '',
    [ff.TRANS_MCC]: '',
    [ff.TRANS_AMOUNT]: '',
}

export const advFields = {
    [ff.TRANS_ID]: '',
    [ff.AUTH_SERVICE_CODE]: '',
    [ff.TRANS_RECURRING]: '',
    [ff.META_PARTIAL_APPROVAL]: '',
    [ff.META_LIFECYCLE_INT]: '',
    [ff.META_LIFECYCLE]: '',
    [ff.META_NETWORK_ID]: '',
    [ff.META_TERMINAL_ID]: '',
    [ff.META_RECURRING]: '',
    [ff.META_FORCE_POST]: '',
    [ff.META_CONDITION]: '',
    [ff.META_PAN_ENTRY]: '',
    [ff.META_PIN_ENTRY]: '',
    [ff.META_CARD_PRES]: '',
    [ff.META_ACCT_PRES]: '',
    [ff.META_SECU_CON]: '',
    [ff.META_PRES_TYPE]: '',
    [ff.META_TERMINAL_TYPE]: '',
    [ff.META_TERMINAL_LOC]: '',
    [ff.META_TERMINAL_OP]: '',
    [ff.META_TERMINAL_ATT]: '',
    [ff.META_CARD_INPUT]: '',
    [ff.META_CARD_RETENTION]: '',
}

export const allFields = {
    ...basicFields,
    ...advFields
}

export const virtualFields = {
    [ff.TRANS_CURRENCY]: '',
    [ff.TRANS_AMOUNT]: '',
    [ff.AUTH_CARD_NUMBER]: '',
    [ff.AUTH_EXPIRATION_DATE]: '',
    [ff.AUTH_ZIPCODE]: '',
    [ff.TRANS_CONVERSION_RATE]: ''
}

export const physicalFields = {
    [ff.TRANS_CURRENCY]: '',
    [ff.TRANS_AMOUNT]: '',
    [ff.AUTH_CARD_NUMBER]: '',
    [ff.AUTH_EXPIRATION_DATE]: '',
    [ff.AUTH_ZIPCODE]: '',
    [ff.AUTH_PIN]: '',
    [ff.AUTH_CVV]: '',
    [ff.TRANS_CONVERSION_RATE]: ''
}

export const initialForm = {
    [VN.CUSTOM]: allFields,
    [VN.VENMO]: virtualFields,
    [VN.PAYPAL]: virtualFields,
    [VN.AMAZON]: virtualFields,
    [VN.GREEN_DOT]: virtualFields,
    [VN.UBER]: virtualFields,
    [VN.RESTAURANT]: virtualFields,
    [VN.GAS_STATION]: physicalFields,
    [VN.WHOLE_FOODS]: physicalFields,
    [VN.ATM]: physicalFields,
}

export const formFields = (formType) => {
    // accepts params to see which formType
    return {
        [ff.TRANS_CURRENCY]: {
            formType: 'TYPE_DROPDOWN',
            label: 'Payment',
            searchable: true,
            placeholder: 'USD',
            propName: ff.TRANS_CURRENCY,
            className: 'form-dropdown inverse form-currency col-3s',
            scrollLimit: 3,
            options: util.getCurrencyOpt(),
        },
        [ff.TRANS_AMOUNT]: {
            formType: 'TYPE_NUMBERINPUT',
            propName: ff.TRANS_AMOUNT,
            className: 'form-transaction col-2s',
            label: 'Amount *',
            placeholder: 'Amount'
        },
        [ff.TRANS_TYPE]: {
            formType: 'TYPE_DROPDOWN',
            propName: ff.TRANS_TYPE,
            label: 'Transaction Type',
            className: formType === 'custom' ? 'form-dropdown inverse col-5s' : 'form-dropdown inverse col-3a',
            scrollLimit: 3,
            options: transactionTypeOptions
        },
        [ff.TRANS_CONVERSION_RATE]: {
            formType: 'TYPE_INPUT',
            propName: ff.TRANS_CONVERSION_RATE,
            className: formType === 'custom' ? 'form-conversion col-3s' : 'form-conversion col-4s',
            label: 'Conversion Rate',
            maxLength: 4,
            placeholder: ''
        },
       [ff.AUTH_CARD_NUMBER]:{
            propName: ff.AUTH_CARD_NUMBER,
            isChild: true
        },
        [ff.AUTH_CVV]: {
            formType: 'TYPE_INPUT',
            propName: ff.AUTH_CVV,
            className: formType === 'custom' ? 'col-3s ' : ' col-3a',
            label: 'CVV',
            maxLength: 3,
            placeholder: '000'
        },
        [ff.AUTH_ZIPCODE]: {
            formType: 'TYPE_INPUT',
            propName: ff.AUTH_ZIPCODE,
            className: 'col-3s',
            label: 'Billing Zip Code *',
            placeholder: '92345',
            maxLength: 5
        },
        [ff.AUTH_EXPIRATION_DATE]: {
            propName: ff.AUTH_EXPIRATION_DATE,
            isChild: true
        },
        [ff.MERCH_PLATFORM_NAME]: {
            formType: 'TYPE_INPUT',
            propName: ff.MERCH_PLATFORM_NAME,
            label: 'Merchant Name',
            className: 'form-divide col0106',
            placeholder: '',
            maxLength: 26
        },
        [ff.MERCH_ADDRESS]: {
            propName: ff.MERCH_ADDRESS,
            isChild: true,
            className: 'form-divide col-8s',
        },
        [ff.MERCH_CITY]: {
            propName: ff.MERCH_CITY,
            formType: 'TYPE_INPUT',
            label: 'City',
            className:  formType === 'custom' ? 'col0106' : 'col-1a',
        },
        [ff.MERCH_STATE]: {
            formType: 'TYPE_DROPDOWN',
            label: 'State',
            className: formType === 'custom' ? 'form-dropdown inverse col-5s' : 'form-dropdown inverse col-2a',
            propName: ff.MERCH_STATE,
            searchable: true,
            scrollLimit: 3,
            options: stateOptions
        },
        [ff.MERCH_COUNTRY]: {
            formType: 'TYPE_DROPDOWN',
            label: 'Country',
            searchable: true,
            className: formType === 'custom' ? 'form-dropdown inverse col-3s' : 'form-dropdown inverse col-3a',
            propName: ff.MERCH_COUNTRY,
            options: countryOptions
        },
        [ff.TRANS_MCC]: {
            formType: 'TYPE_DROPDOWN',
            label: 'Merchant Category',
            searchable: true,
            isFlipped: true,
            placeholder: '',
            className: formType === 'custom' ? 'form-dropdown inverse col-5s dropdown-menu-enlarge' :  'form-dropdown inverse col-4a',
            propName: ff.TRANS_MCC,
            scrollLimit: 6,
            options: util.getMCC(),
        },
        [ff.AUTH_PAYMENT_TYPE]: {
            formType: 'TYPE_DROPDOWN',
            propName: ff.AUTH_PAYMENT_TYPE,
            label: 'Payment Type',
            isFlipped: true,
            selectionType: 'classic',
            className: formType === 'custom' ? 'form-dropdown  inverse col-5s' : 'form-dropdown  inverse col-l',
            options: [
                { key: 'VIRTUAL', text: 'Online' },
                { key: 'PHYSICAL', text: 'Point of Sale (POS)' }
            ]
        },
        [ff.AUTH_PIN]: {
            formType: 'TYPE_INPUT',
            propName: ff.AUTH_PIN,
            className: 'hide',
            label: 'PIN Number*',
            placeholder: ''
        },
    }
}

export const allFormFields = _.map(formFields('custom'), (field) => field);
export const strInputFields =  _.reduce(allFormFields, (acc, f) => {
    if (f.formType === 'TYPE_INPUT') {
        acc.push(f.propName);
    }

    return acc;
}, []);

export const authFormFields = (formType) => ({
    [ff.AUTH_PIN]: {
        formType: 'TYPE_INPUT',
        propName: ff.AUTH_PIN,
        className: formType === 'custom' ? '' : ' col-1a',
        label: 'PIN Number*',
        placeholder: ''
    },
});

export const advFormFields = (formType) => ({
    // [ff.TRANS_ID]: {
    //     formType: 'TYPE_INPUT',
    //     propName: ff.TRANS_ID,
    //     label: 'Transaction ID',
    //     className: 'col-2s',
    //     placeholder: ''
    // },
    // [ff.META_NETWORK_ID]: {
    //     formType: 'TYPE_INPUT',
    //     propName: ff.META_NETWORK_ID,
    //     className: 'col-1s',
    //     label: 'Network ID',
    //     placeholder: ''

    // },
    [ff.META_LIFECYCLE_INT]: {
        formType: 'TYPE_DROPDOWN',
        propName: ff.META_LIFECYCLE_INT,
        placeholder: '',
        label: 'Lifecycle Interval',
        className: 'form-dropdown inverse col-1s',
        scrollLimit: 3,
        options: [
            { key: 'MINUTES', text: 'Minutes' },
            { key: 'HOURS', text: 'Hours' },
            { key: 'DAYS', text: 'Days' }
        ],
    },
    [ff.META_LIFECYCLE]: {
        formType: 'TYPE_NUMBERINPUT',
        min: 0,
        max: 100,
        propName: ff.META_LIFECYCLE,
        label: 'Lifecycle Value',
        className: 'col-1s',
        placeholder: '',
        maxLength: 4
    },
    [ff.META_PARTIAL_APPROVAL]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Partial Payment?',
        placeholder: '',
        propName: ff.META_PARTIAL_APPROVAL,
        className: 'form-dropdown inverse col-1s',
        scrollLimit: 3,
        options: [
            { key: 'true', text: 'Yes' },
            { key: 'false', text: 'No' }
        ],
    },
    [ff.META_RECURRING]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Recurring?',
        placeholder: '',
        propName: ff.META_RECURRING,
        className: 'form-dropdown inverse col-1s',
        scrollLimit: 3,
        options: [
            { key: 'true', text: 'Yes' },
            { key: 'false', text: 'No' }
        ],
    },
    // newly added field
    [ff.META_FORCE_POST]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Force Post?',
        placeholder: '',
        propName: ff.META_FORCE_POST,
        className: 'form-dropdown inverse col-1s',
        scrollLimit: 3,
        options: [
            { key: 'true', text: 'Yes' },
            { key: 'false', text: 'No' }
        ],
    },
    [ff.META_CONDITION]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Condition Code',
        placeholder: '',
        propName: ff.META_CONDITION,
        className: 'form-divide--m form-dropdown inverse col-1c',
        scrollLimit: 3,
        options: conditionOptions,
    },
    [ff.META_PAN_ENTRY]: {
        formType: 'TYPE_DROPDOWN',
        label: 'PAN Entry Mode',
        placeholder: '',
        propName: ff.META_PAN_ENTRY,
        className: 'form-divide--m form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: panEntryOptions,
    },
    [ff.META_PIN_ENTRY]: {
        formType: 'TYPE_DROPDOWN',
        label: 'PIN Entry Mode',
        placeholder: '',
        propName: ff.META_PIN_ENTRY,
        className: 'form-divide--m form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: pinEntryOptions,
    },
    [ff.META_PRES_TYPE]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Presentment Type',
        placeholder: '',
        propName: ff.META_PRES_TYPE,
        className: 'form-divide--m form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: presentmentOptions,
    },
    [ff.META_CARD_PRES]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Card Presence',
        placeholder: '',
        propName: ff.META_CARD_PRES,
        className: 'form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: cardPresenceOptions,
    },
    [ff.META_ACCT_PRES]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Accountholder Presence',
        placeholder: '',
        propName: ff.META_ACCT_PRES,
        className: 'form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: cardHolderPresOptions,
    },
    [ff.META_SECU_CON]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Security Concern',
        placeholder: '',
        propName: ff.META_SECU_CON,
        className: 'form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: securityConditionOptions
    },
    [ff.META_TERMINAL_ID]: {
        formType: 'TYPE_INPUT',
        propName: ff.META_TERMINAL_ID,
        label: 'Terminal ID',
        maxLength: 3,
        className: 'form-divide form-divide--m col-1c',
        placeholder: '',
    },
    [ff.META_TERMINAL_TYPE]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Terminal Type',
        placeholder: '',
        propName: ff.META_TERMINAL_TYPE,
        className: 'form-divide--m form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: terminalTypeOptions,
    },
    [ff.META_TERMINAL_LOC]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Terminal Location',
        placeholder: '',
        propName: ff.META_TERMINAL_LOC,
        className: 'form-divide--m form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: terminalLocOptions,
    },
    [ff.META_TERMINAL_ATT]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Terminal Attendance',
        placeholder: '',
        propName: ff.META_TERMINAL_ATT,
        className: 'form-divide--m form-dropdown inverse col-2s',
        scrollLimit: 3,
        options: attendanceOptions,
    },
    [ff.META_TERMINAL_OP]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Terminal Operator',
        placeholder: '',
        propName: ff.META_TERMINAL_OP,
        className: 'form-dropdown inverse col-2s',
        scrollLimit: 3,
        isFlipped: true,
        options: terminalOpOptions,
    },
    [ff.META_CARD_INPUT]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Card Input Capability',
        placeholder: '',
        propName: ff.META_CARD_INPUT,
        className: 'form-dropdown inverse col-2s',
        scrollLimit: 3,
        isFlipped: true,
        options: inputCapOptions,
    },
    [ff.META_CARD_RETENTION]: {
        formType: 'TYPE_DROPDOWN',
        label: 'Card Retention Capability',
        placeholder: '',
        propName: ff.META_CARD_RETENTION,
        className: 'form-dropdown inverse col-2s',
        scrollLimit: 3,
        isFlipped: true,
        options: cardRetOptions,
    },
});

export const virtualFormFields = (props) => {
    const virtualFields = [
        ff.TRANS_CURRENCY,
        ff.TRANS_AMOUNT,
        ff.TRANS_CONVERSION_RATE,
        ff.AUTH_CARD_NUMBER,
        ff.AUTH_EXPIRATION_DATE,
        ff.AUTH_ZIPCODE,
    ];

    return _.map(virtualFields, (field) => {
        return formFields('virtual')[field];
    });
};

export const physicalFormFields = (props) => {
    const physicalFields = [
        ff.TRANS_CURRENCY,
        ff.TRANS_AMOUNT,
        ff.TRANS_CONVERSION_RATE,
        ff.AUTH_CARD_NUMBER,
        ff.AUTH_EXPIRATION_DATE,
        ff.AUTH_ZIPCODE,
    ];

    return _.map(physicalFields, (field) => {
        return formFields('physical')[field];
    });
}

export function formChildren(state, handleUpdate) {
    return (
        [
            <LocationSearchInput
                key={ff.MERCH_ADDRESS}
                fieldName={ff.MERCH_ADDRESS}
                label={'Merchant Address'}
                address={state[VN.CUSTOM][ff.MERCH_ADDRESS]}
                handleUpdate={handleUpdate}
                className='col-r'
            />,
        ]
    )
}

export function allformChildren(state, handleUpdate, vendor) {
    return (
        [
            <CustomNumberInput
                key={ff.AUTH_CARD_NUMBER}
                propName={ff.AUTH_CARD_NUMBER}
                className={vendor === VN.CUSTOM ? 'col0106' : 'col0106'}
                format={util.getFormattedCredit}
                label='Card Number *'
                onChange={handleUpdate}
                maxLength='19'
                placeholder='0000-0000-0000-0000'
            />,
            <CustomNumberInput
                key={ff.AUTH_EXPIRATION_DATE}
                propName={ff.AUTH_EXPIRATION_DATE}
                className={vendor === VN.CUSTOM ? 'col-2s' : 'col-4s'}
                onChange={handleUpdate}
                placeholder='MM/YY'
                maxLength='5'
                format={util.getFormatedExpDate}
                label='Exp Date *'
            />,
        ]
    )
}